import SERVICES from '../services/service';
export const _searchData = async(language) => {
    // var result = [
    //     {
    //         "id": 1,
    //         "name": "iPhone 11 Pro Max",
    //         "route": '/model/?device=iPhone/?model=iPhone-11-Pro-Max',
    //         "asRoute": '/' + language + '/' + 'iPhone-Repair-Shop' + '/iPhone-11-Pro-Max-Repair',
    //         "isIssue": false
    //     },
    //     {
    //         "id": 2,
    //         "name": "iPhone 11 Pro",
    //         "route": '/model/?device=iPhone/?model=iPhone-11-Pro',
    //         "asRoute": '/' + language + '/' + 'iPhone-Repair-Shop' + '/iPhone-11-Pro-Repair',
    //         "isIssue": false
    //     },
    //     {
    //         "id": 3,
    //         "name": "iPhone 11",
    //         "route": '/model/?device=iPhone/?model=iPhone-11',
    //         "asRoute": '/' + language + '/' + 'iPhone-Repair-Shop' + '/iPhone-11-Repair',
    //         "isIssue": false
    //     },
    //     {
    //         "id": 4,
    //         "name": "iPhone XS Max",
    //         "route": '/model/?device=iPhone/?model=iPhone-XS-Max',
    //         "asRoute": '/' + language + '/' + 'iPhone-Repair-Shop' + '/iPhone-XS-Max-Repair',
    //         "isIssue": false
    //     },
    //     {
    //         "id": 5,
    //         "name": "iPhone XS",
    //         "route": '/model/?device=iPhone/?model=iPhone-XS',
    //         "asRoute": '/' + language + '/' + 'iPhone-Repair-Shop' + '/iPhone-XS-Repair',
    //         "isIssue": false
    //     },
    //     {
    //         "id": 6,
    //         "name": "iPhone XR",
    //         "route": '/model/?device=iPhone/?model=iPhone-XR',
    //         "asRoute": '/' + language + '/' + 'iPhone-Repair-Shop' + '/iPhone-XR-Repair',
    //         "isIssue": false
    //     },
    //     {
    //         "id": 7,
    //         "name": "iPhone X",
    //         "route": '/model/?device=iPhone/?model=iPhone-X',
    //         "asRoute": '/' + language + '/' + 'iPhone-Repair-Shop' + '/iPhone-X-Repair',
    //         "isIssue": false
    //     },
    //     {
    //         "id": 8,
    //         "name": "iPhone 8 Plus",
    //         "route": '/model/?device=iPhone/?model=iPhone-8-Plus',
    //         "asRoute": '/' + language + '/' + 'iPhone-Repair-Shop' + '/iPhone-8-Plus-Repair',
    //         "isIssue": false
    //     },
    //     {
    //         "id": 9,
    //         "name": "iPhone 8",
    //         "route": '/model/?device=iPhone/?model=iPhone-8',
    //         "asRoute": '/' + language + '/' + 'iPhone-Repair-Shop' + '/iPhone-8-Repair',
    //         "isIssue": false
    //     },
    //     {
    //         "id": 10,
    //         "name": "iPhone 7 Plus",
    //         "route": '/model/?device=iPhone/?model=iPhone-7-Plus',
    //         "asRoute": '/' + language + '/' + 'iPhone-Repair-Shop' + '/iPhone-7-Plus-Repair',
    //         "isIssue": false
    //     },
    //     {
    //         "id": 11,
    //         "name": "iPhone 7",
    //         "route": '/model/?device=iPhone/?model=iPhone-7',
    //         "asRoute": '/' + language + '/' + 'iPhone-Repair-Shop' + '/iPhone-7-Repair',
    //         "isIssue": false
    //     },
    //     {
    //         "id": 12,
    //         "name": "iPhone 6s Plus",
    //         "route": '/model/?device=iPhone/?model=iPhone-6s-Plus',
    //         "asRoute": '/' + language + '/' + 'iPhone-Repair-Shop' + '/iPhone-6s-Plus-Repair',
    //         "isIssue": false
    //     },
    //     {
    //         "id": 13,
    //         "name": "iPhone 6s",
    //         "route": '/model/?device=iPhone/?model=iPhone-6s',
    //         "asRoute": '/' + language + '/' + 'iPhone-Repair-Shop' + '/iPhone-6s-Repair',
    //         "isIssue": false
    //     },
    //     {
    //         "id": 14,
    //         "name": "iPhone 6 Plus",
    //         "route": '/model/?device=iPhone/?model=iPhone-6-Plus',
    //         "asRoute": '/' + language + '/' + 'iPhone-Repair-Shop' + '/iPhone-6-Plus-Repair',
    //         "isIssue": false
    //     },
    //     {
    //         "id": 15,
    //         "name": "iPhone 6",
    //         "route": '/model/?device=iPhone/?model=iPhone-6',
    //         "asRoute": '/' + language + '/' + 'iPhone-Repair-Shop' + '/iPhone-6-Repair',
    //         "isIssue": false
    //     },
    //     {
    //         "id": 16,
    //         "name": "iPhone SE",
    //         "route": '/model/?device=iPhone/?model=iPhone-SE',
    //         "asRoute": '/' + language + '/' + 'iPhone-Repair-Shop' + '/iPhone-SE-Repair',
    //         "isIssue": false
    //     },
    //     {
    //         "id": 17,
    //         "name": "iPhone 5s",
    //         "route": '/model/?device=iPhone/?model=iPhone-5s',
    //         "asRoute": '/' + language + '/' + 'iPhone-Repair-Shop' + '/iPhone-5s-Repair',
    //         "isIssue": false
    //     },
    //     {
    //         "id": 18,
    //         "name": "iPhone 5c",
    //         "route": '/model/?device=iPhone/?model=iPhone-5c',
    //         "asRoute": '/' + language + '/' + 'iPhone-Repair-Shop' + '/iPhone-5c-Repair',
    //         "isIssue": false
    //     },
    //     {
    //         "id": 19,
    //         "name": "iPhone 5",
    //         "route": '/model/?device=iPhone/?model=iPhone-5',
    //         "asRoute": '/' + language + '/' + 'iPhone-Repair-Shop' + '/iPhone-5-Repair',
    //         "isIssue": false
    //     },
    //     {
    //         "id": 20,
    //         "name": "iPad",
    //         "route": '/model/?device=iPad/?model=iPad',
    //         "asRoute": '/' + language + '/' + 'iPad-Repair-Shop' + '/iPad-Repair',
    //         "isIssue": false
    //     },
    //     {
    //         "id": 21,
    //         "name": "iPad Air",
    //         "route": '/model/?device=iPad/?model=iPad-Air',
    //         "asRoute": '/' + language + '/' + 'iPad-Repair-Shop' + '/iPad-Air-Repair',
    //         "isIssue": false
    //     },
    //     {
    //         "id": 22,
    //         "name": "iPad Mini",
    //         "route": '/model/?device=iPad/?model=iPad-Mini',
    //         "asRoute": '/' + language + '/' + 'iPad-Repair-Shop' + '/iPad-Mini-Repair',
    //         "isIssue": false
    //     },
    //     {
    //         "id": 23,
    //         "name": "iPad Pro",
    //         "route": '/model/?device=iPad/?model=iPad-Pro',
    //         "asRoute": '/' + language + '/' + 'iPad-Repair-Shop' + '/iPad-Pro-Repair',
    //         "isIssue": false
    //     },
    //     {
    //         "id": 24,
    //         "name": "MacBook",
    //         "route": '/model/?device=MacBook/?model=MacBook',
    //         "asRoute": '/' + language + '/' + 'MacBook-Repair-Shop' + '/MacBook-Repair',
    //         "isIssue": false
    //     },
    //     {
    //         "id": 25,
    //         "name": "MacBook Pro Retina",
    //         "route": '/model/?device=MacBook/?model=MacBook-Pro-Retina',
    //         "asRoute": '/' + language + '/' + 'MacBook-Repair-Shop' + '/MacBook-Pro-Retina-Repair',
    //         "isIssue": false
    //     },
    //     {
    //         "id": 26,
    //         "name": "MacBook Pro",
    //         "route": '/model/?device=MacBook/?model=MacBook-Pro',
    //         "asRoute": '/' + language + '/' + 'MacBook-Repair-Shop' + '/MacBook-Pro-Repair',
    //         "isIssue": false
    //     },
    //     {
    //         "id": 27,
    //         "name": "MacBook Air",
    //         "route": '/model/?device=MacBook/?model=MacBook-Air',
    //         "asRoute": '/' + language + '/' + 'MacBook-Repair-Shop' + '/MacBook-Air-Repair',
    //         "isIssue": false
    //     },
    //     // {
    //     //     "id": 28,
    //     //     "name": "MacBook Air",
    //     //     "route": '/model/?device=MacBook/?model=MacBook-Air',
    //     //     "asRoute": '/' + language + '/' + 'MacBook-Repair-Shop' + '/MacBook-Air-Repair',
    //     //     "isIssue": false
    //     // },
    //     {
    //         "id": 29,
    //         "name": "Apple Watch Series 5",
    //         "route": '/model/?device=iWatch/?model=Apple-Watch-Series-5',
    //         "asRoute": '/' + language + '/' + 'iWatch-Repair-Shop' + '/Apple-Watch-Series-5-Repair',
    //         "isIssue": false
    //     },
    //     {
    //         "id": 30,
    //         "name": "Apple Watch Series 4",
    //         "route": '/model/?device=iWatch/?model=Apple-Watch-Series-4',
    //         "asRoute": '/' + language + '/' + 'iWatch-Repair-Shop' + '/Apple-Watch-Series-4-Repair',
    //         "isIssue": false
    //     },
    //     {
    //         "id": 31,
    //         "name": "Apple Watch Series 3",
    //         "route": '/model/?device=iWatch/?model=Apple-Watch-Series-3',
    //         "asRoute": '/' + language + '/' + 'iWatch-Repair-Shop' + '/Apple-Watch-Series-3-Repair',
    //         "isIssue": false
    //     },
    //     {
    //         "id": 32,
    //         "name": "Apple Watch Series 2",
    //         "route": '/model/?device=iWatch/?model=Apple-Watch-Series-2',
    //         "asRoute": '/' + language + '/' + 'iWatch-Repair-Shop' + '/Apple-Watch-Series-2-Repair',
    //         "isIssue": false
    //     },
    //     {
    //         "id": 33,
    //         "name": "Apple Watch Series 1",
    //         "route": '/model/?device=iWatch/?model=Apple-Watch-Series-1',
    //         "asRoute": '/' + language + '/' + 'iWatch-Repair-Shop' + '/Apple-Watch-Series-1-Repair',
    //         "isIssue": false
    //     },
    //     {
    //         "id": 34,
    //         "name": "iWatch",
    //         "route": '/brand/?device=iWatch',
    //         "asRoute": '/' + language + '/iWatch-Repair-Shop',
    //         "isIssue": false
    //     },
    //     {
    //         "id": 35,
    //         "name": "iPhone",
    //         "route": '/brand/?device=iPhone',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop',
    //         "isIssue": false
    //     },
    //     {
    //         "id": 36,
    //         "name": "iPad",
    //         "route": '/brand/?device=iPad',
    //         "asRoute": '/' + language + '/iPad-Repair-Shop',
    //         "isIssue": false
    //     },
    //     {
    //         "id": 37,
    //         "name": "MacBook",
    //         "route": '/brand/?device=MacBook',
    //         "asRoute": '/' + language + '/MacBook-Repair-Shop',
    //         "isIssue": false
    //     },
    //     {
    //         "id": 38,
    //         "name": "Apple Watch Screen/Display Repair & Replacement for Apple Watch Series 5",
    //         "route": '/model/?device=iWatch/?model=Apple-Watch-Series-5',
    //         "asRoute": '/' + language + '/iWatch-Repair-Shop/Apple-Watch-Series-5-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 39,
    //         "name": "Apple Watch Battery Repair & Replacement for Apple Watch Series 5",
    //         "route": '/model/?device=iWatch/?model=Apple-Watch-Series-5',
    //         "asRoute": '/' + language + '/iWatch-Repair-Shop/Apple-Watch-Series-5-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 40,
    //         "name": "Other Problems - We Will Contact you to find out more for Apple Watch Series 5",
    //         "route": '/model/?device=iWatch/?model=Apple-Watch-Series-5',
    //         "asRoute": '/' + language + '/iWatch-Repair-Shop/Apple-Watch-Series-5-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 95,
    //         "name": "Apple Watch Screen/Display Repair & Replacement for Apple Watch Series 4",
    //         "route": '/model/?device=iWatch/?model=Apple-Watch-Series-4',
    //         "asRoute": '/' + language + '/iWatch-Repair-Shop/Apple-Watch-Series-4-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 96,
    //         "name": "Apple Watch Battery Repair & Replacement for Apple Watch Series 4",
    //         "route": '/model/?device=iWatch/?model=Apple-Watch-Series-4',
    //         "asRoute": '/' + language + '/iWatch-Repair-Shop/Apple-Watch-Series-4-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 96,
    //         "name": "Other Problems - We Will Contact you to find out more for Apple Watch Series 4",
    //         "route": '/model/?device=iWatch/?model=Apple-Watch-Series-4',
    //         "asRoute": '/' + language + '/iWatch-Repair-Shop/Apple-Watch-Series-4-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 97,
    //         "name": "Apple Watch Screen/Display Repair & Replacement for Apple Watch Series 3",
    //         "route": '/model/?device=iWatch/?model=Apple-Watch-Series-3',
    //         "asRoute": '/' + language + '/iWatch-Repair-Shop/Apple-Watch-Series-3-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 98,
    //         "name": "Apple Watch Battery Repair & Replacement for Apple Watch Series 3",
    //         "route": '/model/?device=iWatch/?model=Apple-Watch-Series-3',
    //         "asRoute": '/' + language + '/iWatch-Repair-Shop/Apple-Watch-Series-3-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 99,
    //         "name": "Other Problems - We Will Contact you to find out more for Apple Watch Series 3",
    //         "route": '/model/?device=iWatch/?model=Apple-Watch-Series-3',
    //         "asRoute": '/' + language + '/iWatch-Repair-Shop/Apple-Watch-Series-3-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 100,
    //         "name": "Apple Watch Screen/Display Repair & Replacement for Apple Watch Series 2",
    //         "route": '/model/?device=iWatch/?model=Apple-Watch-Series-2',
    //         "asRoute": '/' + language + '/iWatch-Repair-Shop/Apple-Watch-Series-2-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 101,
    //         "name": "Apple Watch Battery Repair & Replacement for Apple Watch Series 2",
    //         "route": '/model/?device=iWatch/?model=Apple-Watch-Series-2',
    //         "asRoute": '/' + language + '/iWatch-Repair-Shop/Apple-Watch-Series-2-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 102,
    //         "name": "Other Problems - We Will Contact you to find out more for Apple Watch Series 2",
    //         "route": '/model/?device=iWatch/?model=Apple-Watch-Series-2',
    //         "asRoute": '/' + language + '/iWatch-Repair-Shop/Apple-Watch-Series-2-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 100,
    //         "name": "Apple Watch Screen/Display Repair & Replacement for Apple Watch Series 1",
    //         "route": '/model/?device=iWatch/?model=Apple-Watch-Series-1',
    //         "asRoute": '/' + language + '/iWatch-Repair-Shop/Apple-Watch-Series-1-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 101,
    //         "name": "Apple Watch Battery Repair & Replacement for Apple Watch Series 1",
    //         "route": '/model/?device=iWatch/?model=Apple-Watch-Series-1',
    //         "asRoute": '/' + language + '/iWatch-Repair-Shop/Apple-Watch-Series-1-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 102,
    //         "name": "Other Problems - We Will Contact you to find out more for Apple Watch Series 1",
    //         "route": '/model/?device=iWatch/?model=Apple-Watch-Series-1',
    //         "asRoute": '/' + language + '/iWatch-Repair-Shop/Apple-Watch-Series-1-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 41,
    //         "name": "Battery Repair & Replacement for iPhone 11 Pro Max",
    //         "route": '/model/?device=iPhone/?model=iPhone-11-Pro-Max',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-11-Pro-Max-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 42,
    //         "name": "Charging Flex/Strip Repair & Replacement for iPhone 11 Pro Max",
    //         "route": '/model/?device=iPhone/?model=iPhone-11-Pro-Max',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-11-Pro-Max-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 43,
    //         "name": "Speaker/Ringer Repair & Replacement for iPhone 11 Pro Max",
    //         "route": '/model/?device=iPhone/?model=iPhone-11-Pro-Max',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-11-Pro-Max-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 44,
    //         "name": "Mic Repair & Replacement for iPhone 11 Pro Max",
    //         "route": '/model/?device=iPhone/?model=iPhone-11-Pro-Max',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-11-Pro-Max-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 45,
    //         "name": "Ear Speaker Repair & Replacement for iPhone 11 Pro Max",
    //         "route": '/model/?device=iPhone/?model=iPhone-11-Pro-Max',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-11-Pro-Max-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 46,
    //         "name": "Front Camera Repair & Replacement for iPhone 11 Pro Max",
    //         "route": '/model/?device=iPhone/?model=iPhone-11-Pro-Max',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-11-Pro-Max-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 47,
    //         "name": "Rear Camera Repair & Replacement for iPhone 11 Pro Max",
    //         "route": '/model/?device=iPhone/?model=iPhone-11-Pro-Max',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-11-Pro-Max-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 48,
    //         "name": "Light & Motion Sensor Repair & Replacement for iPhone 11 Pro Max",
    //         "route": '/model/?device=iPhone/?model=iPhone-11-Pro-Max',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-11-Pro-Max-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 49,
    //         "name": "Headphone Repair & Replacement for iPhone 11 Pro Max",
    //         "route": '/model/?device=iPhone/?model=iPhone-11-Pro-Max',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-11-Pro-Max-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 50,
    //         "name": "Power Button Repair & Replacement for iPhone 11 Pro Max",
    //         "route": '/model/?device=iPhone/?model=iPhone-11-Pro-Max',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-11-Pro-Max-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 51,
    //         "name": "Volume Button Repair & Replacement for iPhone 11 Pro Max",
    //         "route": '/model/?device=iPhone/?model=iPhone-11-Pro-Max',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-11-Pro-Max-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 52,
    //         "name": "Frame & Housing Repair & Replacement for iPhone 11 Pro Max",
    //         "route": '/model/?device=iPhone/?model=iPhone-11-Pro-Max',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-11-Pro-Max-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 53,
    //         "name": "Other Problems - We will Contact you to find out more for iPhone 11 Pro Max",
    //         "route": '/model/?device=iPhone/?model=iPhone-11-Pro-Max',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-11-Pro-Max-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 103,
    //         "name": "Battery Repair & Replacement for iPhone 11 Pro",
    //         "route": '/model/?device=iPhone/?model=iPhone-11-Pro',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-11-Pro-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 104,
    //         "name": "Charging Flex/Strip Repair & Replacement for iPhone 11 Pro",
    //         "route": '/model/?device=iPhone/?model=iPhone-11-Pro',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-11-Pro-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 105,
    //         "name": "Speaker/Ringer Repair & Replacement for iPhone 11 Pro",
    //         "route": '/model/?device=iPhone/?model=iPhone-11-Pro',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-11-Pro-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 106,
    //         "name": "Mic Repair & Replacement for iPhone 11 Pro",
    //         "route": '/model/?device=iPhone/?model=iPhone-11-Pro',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-11-Pro-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 107,
    //         "name": "Ear Speaker Repair & Replacement for iPhone 11 Pro",
    //         "route": '/model/?device=iPhone/?model=iPhone-11-Pro',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-11-Pro-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 108,
    //         "name": "Front Camera Repair & Replacement for iPhone 11 Pro",
    //         "route": '/model/?device=iPhone/?model=iPhone-11-Pro',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-11-Pro-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 109,
    //         "name": "Rear Camera Repair & Replacement for iPhone 11 Pro",
    //         "route": '/model/?device=iPhone/?model=iPhone-11-Pro',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-11-Pro-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 110,
    //         "name": "Light & Motion Sensor Repair & Replacement for iPhone 11 Pro",
    //         "route": '/model/?device=iPhone/?model=iPhone-11-Pro',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-11-Pro-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 111,
    //         "name": "Headphone Repair & Replacement for iPhone 11 Pro",
    //         "route": '/model/?device=iPhone/?model=iPhone-11-Pro',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-11-Pro-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 112,
    //         "name": "Power Button Repair & Replacement for iPhone 11 Pro",
    //         "route": '/model/?device=iPhone/?model=iPhone-11-Pro',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-11-Pro-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 113,
    //         "name": "Volume Button Repair & Replacement for iPhone 11 Pro",
    //         "route": '/model/?device=iPhone/?model=iPhone-11-Pro',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-11-Pro-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 114,
    //         "name": "Frame & Housing Repair & Replacement for iPhone 11 Pro",
    //         "route": '/model/?device=iPhone/?model=iPhone-11-Pro',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-11-Pro-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 115,
    //         "name": "Other Problems - We will Contact you to find out more for iPhone 11 Pro",
    //         "route": '/model/?device=iPhone/?model=iPhone-11-Pro',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-11-Pro-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 116,
    //         "name": "Battery Repair & Replacement for iPhone 11",
    //         "route": '/model/?device=iPhone/?model=iPhone-11',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-11-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 117,
    //         "name": "Charging Flex/Strip Repair & Replacement for iPhone 11",
    //         "route": '/model/?device=iPhone/?model=iPhone-11',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-11-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 118,
    //         "name": "Speaker/Ringer Repair & Replacement for iPhone 11",
    //         "route": '/model/?device=iPhone/?model=iPhone-11',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-11-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 119,
    //         "name": "Mic Repair & Replacement for iPhone 11",
    //         "route": '/model/?device=iPhone/?model=iPhone-11',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-11-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 120,
    //         "name": "Ear Speaker Repair & Replacement for iPhone 11",
    //         "route": '/model/?device=iPhone/?model=iPhone-11',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-11-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 121,
    //         "name": "Front Camera Repair & Replacement for iPhone 11",
    //         "route": '/model/?device=iPhone/?model=iPhone-11',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-11-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 122,
    //         "name": "Rear Camera Repair & Replacement for iPhone 11",
    //         "route": '/model/?device=iPhone/?model=iPhone-11',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-11-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 123,
    //         "name": "Light & Motion Sensor Repair & Replacement for iPhone 11",
    //         "route": '/model/?device=iPhone/?model=iPhone-11',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-11-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 124,
    //         "name": "Headphone Repair & Replacement for iPhone 11",
    //         "route": '/model/?device=iPhone/?model=iPhone-11',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-11-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 125,
    //         "name": "Power Button Repair & Replacement for iPhone 11",
    //         "route": '/model/?device=iPhone/?model=iPhone-11',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-11-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 126,
    //         "name": "Volume Button Repair & Replacement for iPhone 11",
    //         "route": '/model/?device=iPhone/?model=iPhone-11',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-11-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 127,
    //         "name": "Frame & Housing Repair & Replacement for iPhone 11",
    //         "route": '/model/?device=iPhone/?model=iPhone-11',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-11-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 128,
    //         "name": "Other Problems - We will Contact you to find out more for iPhone 11",
    //         "route": '/model/?device=iPhone/?model=iPhone-11',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-11-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 129,
    //         "name": "Battery Repair & Replacement for iPhone XS Max",
    //         "route": '/model/?device=iPhone/?model=iPhone-XS-Max',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-XS-Max-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 130,
    //         "name": "Charging Flex/Strip Repair & Replacement for iPhone XS Max",
    //         "route": '/model/?device=iPhone/?model=iPhone-XS-Max',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-XS-Max-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 131,
    //         "name": "Speaker/Ringer Repair & Replacement for iPhone XS Max",
    //         "route": '/model/?device=iPhone/?model=iPhone-XS-Max',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-XS-Max-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 132,
    //         "name": "Mic Repair & Replacement for iPhone XS Max",
    //         "route": '/model/?device=iPhone/?model=iPhone-XS-Max',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-XS-Max-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 133,
    //         "name": "Ear Speaker Repair & Replacement for iPhone XS Max",
    //         "route": '/model/?device=iPhone/?model=iPhone-XS-Max',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-XS-Max-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 134,
    //         "name": "Front Camera Repair & Replacement for iPhone XS Max",
    //         "route": '/model/?device=iPhone/?model=iPhone-XS-Max',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-XS-Max-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 135,
    //         "name": "Rear Camera Repair & Replacement for iPhone XS Max",
    //         "route": '/model/?device=iPhone/?model=iPhone-XS-Max',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-XS-Max-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 136,
    //         "name": "Light & Motion Sensor Repair & Replacement for iPhone XS Max",
    //         "route": '/model/?device=iPhone/?model=iPhone-XS-Max',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-XS-Max-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 137,
    //         "name": "Headphone Repair & Replacement for iPhone XS Max",
    //         "route": '/model/?device=iPhone/?model=iPhone-XS-Max',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-XS-Max-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 138,
    //         "name": "Power Button Repair & Replacement for iPhone XS Max",
    //         "route": '/model/?device=iPhone/?model=iPhone-XS-Max',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-XS-Max-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 139,
    //         "name": "Volume Button Repair & Replacement for iPhone XS Max",
    //         "route": '/model/?device=iPhone/?model=iPhone-XS-Max',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-XS-Max-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 140,
    //         "name": "Frame & Housing Repair & Replacement for iPhone XS Max",
    //         "route": '/model/?device=iPhone/?model=iPhone-XS-Max',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-XS-Max-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 141,
    //         "name": "Other Problems - We will Contact you to find out more for iPhone XS Max",
    //         "route": '/model/?device=iPhone/?model=iPhone-XS-Max',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-XS-Max-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 142,
    //         "name": "Battery Repair & Replacement for iPhone XS",
    //         "route": '/model/?device=iPhone/?model=iPhone-XS',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-XS-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 143,
    //         "name": "Charging Flex/Strip Repair & Replacement for iPhone XS",
    //         "route": '/model/?device=iPhone/?model=iPhone-XS',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-XS-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 144,
    //         "name": "Speaker/Ringer Repair & Replacement for iPhone XS",
    //         "route": '/model/?device=iPhone/?model=iPhone-XS',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-XS-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 145,
    //         "name": "Mic Repair & Replacement for iPhone XS",
    //         "route": '/model/?device=iPhone/?model=iPhone-XS',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-XS-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 146,
    //         "name": "Ear Speaker Repair & Replacement for iPhone XS",
    //         "route": '/model/?device=iPhone/?model=iPhone-XS',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-XS-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 147,
    //         "name": "Front Camera Repair & Replacement for iPhone XS",
    //         "route": '/model/?device=iPhone/?model=iPhone-XS',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-XS-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 148,
    //         "name": "Rear Camera Repair & Replacement for iPhone XS",
    //         "route": '/model/?device=iPhone/?model=iPhone-XS',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-XS-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 149,
    //         "name": "Light & Motion Sensor Repair & Replacement for iPhone XS",
    //         "route": '/model/?device=iPhone/?model=iPhone-XS',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-XS-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 150,
    //         "name": "Headphone Repair & Replacement for iPhone XS",
    //         "route": '/model/?device=iPhone/?model=iPhone-XS',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-XS-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 151,
    //         "name": "Power Button Repair & Replacement for iPhone XS",
    //         "route": '/model/?device=iPhone/?model=iPhone-XS',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-XS-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 152,
    //         "name": "Volume Button Repair & Replacement for iPhone XS",
    //         "route": '/model/?device=iPhone/?model=iPhone-XS',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-XS-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 153,
    //         "name": "Frame & Housing Repair & Replacement for iPhone XS",
    //         "route": '/model/?device=iPhone/?model=iPhone-XS',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-XS-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 154,
    //         "name": "Other Problems - We will Contact you to find out more for iPhone XS",
    //         "route": '/model/?device=iPhone/?model=iPhone-XS',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-XS-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 155,
    //         "name": "Battery Repair & Replacement for iPhone XR",
    //         "route": '/model/?device=iPhone/?model=iPhone-XR',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-XR-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 156,
    //         "name": "Charging Flex/Strip Repair & Replacement for iPhone XR",
    //         "route": '/model/?device=iPhone/?model=iPhone-XR',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-XR-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 157,
    //         "name": "Speaker/Ringer Repair & Replacement for iPhone XR",
    //         "route": '/model/?device=iPhone/?model=iPhone-XR',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-XR-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 158,
    //         "name": "Mic Repair & Replacement for iPhone XR",
    //         "route": '/model/?device=iPhone/?model=iPhone-XR',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-XR-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 159,
    //         "name": "Ear Speaker Repair & Replacement for iPhone XR",
    //         "route": '/model/?device=iPhone/?model=iPhone-XR',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-XR-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 160,
    //         "name": "Front Camera Repair & Replacement for iPhone XR",
    //         "route": '/model/?device=iPhone/?model=iPhone-XR',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-XR-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 161,
    //         "name": "Rear Camera Repair & Replacement for iPhone XR",
    //         "route": '/model/?device=iPhone/?model=iPhone-XR',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-XR-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 162,
    //         "name": "Light & Motion Sensor Repair & Replacement for iPhone XR",
    //         "route": '/model/?device=iPhone/?model=iPhone-XR',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-XR-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 163,
    //         "name": "Headphone Repair & Replacement for iPhone XR",
    //         "route": '/model/?device=iPhone/?model=iPhone-XR',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-XR-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 164,
    //         "name": "Power Button Repair & Replacement for iPhone XR",
    //         "route": '/model/?device=iPhone/?model=iPhone-XR',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-XR-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 165,
    //         "name": "Volume Button Repair & Replacement for iPhone XR",
    //         "route": '/model/?device=iPhone/?model=iPhone-XR',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-XR-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 166,
    //         "name": "Frame & Housing Repair & Replacement for iPhone XR",
    //         "route": '/model/?device=iPhone/?model=iPhone-XR',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-XR-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 167,
    //         "name": "Other Problems - We will Contact you to find out more for iPhone XR",
    //         "route": '/model/?device=iPhone/?model=iPhone-XR',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-XR-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 168,
    //         "name": "Battery Repair & Replacement for iPhone X",
    //         "route": '/model/?device=iPhone/?model=iPhone-X',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-X-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 169,
    //         "name": "Charging Flex/Strip Repair & Replacement for iPhone X",
    //         "route": '/model/?device=iPhone/?model=iPhone-X',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-X-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 170,
    //         "name": "Speaker/Ringer Repair & Replacement for iPhone X",
    //         "route": '/model/?device=iPhone/?model=iPhone-X',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-X-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 171,
    //         "name": "Mic Repair & Replacement for iPhone X",
    //         "route": '/model/?device=iPhone/?model=iPhone-X',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-X-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 172,
    //         "name": "Ear Speaker Repair & Replacement for iPhone X",
    //         "route": '/model/?device=iPhone/?model=iPhone-X',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-X-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 173,
    //         "name": "Front Camera Repair & Replacement for iPhone X",
    //         "route": '/model/?device=iPhone/?model=iPhone-X',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-X-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 174,
    //         "name": "Rear Camera Repair & Replacement for iPhone X",
    //         "route": '/model/?device=iPhone/?model=iPhone-X',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-X-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 175,
    //         "name": "Light & Motion Sensor Repair & Replacement for iPhone X",
    //         "route": '/model/?device=iPhone/?model=iPhone-X',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-X-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 176,
    //         "name": "Headphone Repair & Replacement for iPhone X",
    //         "route": '/model/?device=iPhone/?model=iPhone-X',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-X-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 177,
    //         "name": "Power Button Repair & Replacement for iPhone X",
    //         "route": '/model/?device=iPhone/?model=iPhone-X',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-X-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 178,
    //         "name": "Volume Button Repair & Replacement for iPhone X",
    //         "route": '/model/?device=iPhone/?model=iPhone-X',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-X-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 179,
    //         "name": "Frame & Housing Repair & Replacement for iPhone X",
    //         "route": '/model/?device=iPhone/?model=iPhone-X',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-X-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 180,
    //         "name": "Other Problems - We will Contact you to find out more for iPhone X",
    //         "route": '/model/?device=iPhone/?model=iPhone-X',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-X-Repair',
    //         "isIssue": true
    //     },
    //      {
    //         "id": 181,
    //         "name": "Battery Repair & Replacement for iPhone 8 Plus",
    //         "route": '/model/?device=iPhone/?model=iPhone-8-Plus',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-8-Plus-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 182,
    //         "name": "Charging Flex/Strip Repair & Replacement for iPhone 8 Plus",
    //         "route": '/model/?device=iPhone/?model=iPhone-8-Plus',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-8-Plus-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 183,
    //         "name": "Speaker/Ringer Repair & Replacement for iPhone 8 Plus",
    //         "route": '/model/?device=iPhone/?model=iPhone-8-Plus',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-8-Plus-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 184,
    //         "name": "Mic Repair & Replacement for iPhone 8 Plus",
    //         "route": '/model/?device=iPhone/?model=iPhone-8-Plus',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-8-Plus-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 185,
    //         "name": "Ear Speaker Repair & Replacement for iPhone 8 Plus",
    //         "route": '/model/?device=iPhone/?model=iPhone-8-Plus',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-8-Plus-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 186,
    //         "name": "Front Camera Repair & Replacement for iPhone 8 Plus",
    //         "route": '/model/?device=iPhone/?model=iPhone-8-Plus',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-8-Plus-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 187,
    //         "name": "Rear Camera Repair & Replacement for iPhone 8 Plus",
    //         "route": '/model/?device=iPhone/?model=iPhone-8-Plus',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-8-Plus-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 188,
    //         "name": "Light & Motion Sensor Repair & Replacement for iPhone 8 Plus",
    //         "route": '/model/?device=iPhone/?model=iPhone-8-Plus',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-8-Plus-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 189,
    //         "name": "Headphone Repair & Replacement for iPhone 8 Plus",
    //         "route": '/model/?device=iPhone/?model=iPhone-8-Plus',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-8-Plus-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 190,
    //         "name": "Power Button Repair & Replacement for iPhone 8 Plus",
    //         "route": '/model/?device=iPhone/?model=iPhone-8-Plus',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-8-Plus-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 191,
    //         "name": "Volume Button Repair & Replacement for iPhone 8 Plus",
    //         "route": '/model/?device=iPhone/?model=iPhone-8-Plus',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-8-Plus-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 192,
    //         "name": "Frame & Housing Repair & Replacement for iPhone 8 Plus",
    //         "route": '/model/?device=iPhone/?model=iPhone-8-Plus',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-8-Plus-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 193,
    //         "name": "Other Problems - We will Contact you to find out more for iPhone 8 Plus",
    //         "route": '/model/?device=iPhone/?model=iPhone-8-Plus',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-8-Plus-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 194,
    //         "name": "Battery Repair & Replacement for iPhone 8",
    //         "route": '/model/?device=iPhone/?model=iPhone-8',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-8-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 195,
    //         "name": "Charging Flex/Strip Repair & Replacement for iPhone 8",
    //         "route": '/model/?device=iPhone/?model=iPhone-8',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-8-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 196,
    //         "name": "Speaker/Ringer Repair & Replacement for iPhone 8",
    //         "route": '/model/?device=iPhone/?model=iPhone-8',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-8-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 197,
    //         "name": "Mic Repair & Replacement for iPhone 8",
    //         "route": '/model/?device=iPhone/?model=iPhone-8',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-8-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 198,
    //         "name": "Ear Speaker Repair & Replacement for iPhone 8",
    //         "route": '/model/?device=iPhone/?model=iPhone-8',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-8-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 199,
    //         "name": "Front Camera Repair & Replacement for iPhone 8",
    //         "route": '/model/?device=iPhone/?model=iPhone-8',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-8-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 200,
    //         "name": "Rear Camera Repair & Replacement for iPhone 8",
    //         "route": '/model/?device=iPhone/?model=iPhone-8',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-8-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 201,
    //         "name": "Light & Motion Sensor Repair & Replacement for iPhone 8",
    //         "route": '/model/?device=iPhone/?model=iPhone-8',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-8-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 202,
    //         "name": "Headphone Repair & Replacement for iPhone 8",
    //         "route": '/model/?device=iPhone/?model=iPhone-8',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-8-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 203,
    //         "name": "Power Button Repair & Replacement for iPhone 8",
    //         "route": '/model/?device=iPhone/?model=iPhone-8',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-8-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 204,
    //         "name": "Volume Button Repair & Replacement for iPhone 8",
    //         "route": '/model/?device=iPhone/?model=iPhone-8',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-8-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 205,
    //         "name": "Frame & Housing Repair & Replacement for iPhone 8",
    //         "route": '/model/?device=iPhone/?model=iPhone-8',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-8-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 206,
    //         "name": "Other Problems - We will Contact you to find out more for iPhone 8",
    //         "route": '/model/?device=iPhone/?model=iPhone-8',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-8-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 207,
    //         "name": "Battery Repair & Replacement for iPhone 7 Plus",
    //         "route": '/model/?device=iPhone/?model=iPhone-7-Plus',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-7-Plus-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 208,
    //         "name": "Charging Flex/Strip Repair & Replacement for iPhone 7 Plus",
    //         "route": '/model/?device=iPhone/?model=iPhone-7-Plus',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-7-Plus-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 209,
    //         "name": "Speaker/Ringer Repair & Replacement for iPhone 7 Plus",
    //         "route": '/model/?device=iPhone/?model=iPhone-7-Plus',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-7-Plus-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 210,
    //         "name": "Mic Repair & Replacement for iPhone 7 Plus",
    //         "route": '/model/?device=iPhone/?model=iPhone-7-Plus',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-7-Plus-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 211,
    //         "name": "Ear Speaker Repair & Replacement for iPhone 7 Plus",
    //         "route": '/model/?device=iPhone/?model=iPhone-7-Plus',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-7-Plus-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 212,
    //         "name": "Front Camera Repair & Replacement for iPhone 7 Plus",
    //         "route": '/model/?device=iPhone/?model=iPhone-7-Plus',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-7-Plus-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 213,
    //         "name": "Rear Camera Repair & Replacement for iPhone 7 Plus",
    //         "route": '/model/?device=iPhone/?model=iPhone-7-Plus',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-7-Plus-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 214,
    //         "name": "Light & Motion Sensor Repair & Replacement for iPhone 7 Plus",
    //         "route": '/model/?device=iPhone/?model=iPhone-7-Plus',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-7-Plus-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 215,
    //         "name": "Headphone Repair & Replacement for iPhone 7 Plus",
    //         "route": '/model/?device=iPhone/?model=iPhone-7-Plus',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-7-Plus-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 216,
    //         "name": "Power Button Repair & Replacement for iPhone 7 Plus",
    //         "route": '/model/?device=iPhone/?model=iPhone-7-Plus',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-7-Plus-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 217,
    //         "name": "Volume Button Repair & Replacement for iPhone 7 Plus",
    //         "route": '/model/?device=iPhone/?model=iPhone-7-Plus',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-7-Plus-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 218,
    //         "name": "Frame & Housing Repair & Replacement for iPhone 7 Plus",
    //         "route": '/model/?device=iPhone/?model=iPhone-7-Plus',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-7-Plus-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 219,
    //         "name": "Other Problems - We will Contact you to find out more for iPhone 7 Plus",
    //         "route": '/model/?device=iPhone/?model=iPhone-7-Plus',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-7-Plus-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 220,
    //         "name": "Battery Repair & Replacement for iPhone 7",
    //         "route": '/model/?device=iPhone/?model=iPhone-7',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-7-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 221,
    //         "name": "Charging Flex/Strip Repair & Replacement for iPhone 7",
    //         "route": '/model/?device=iPhone/?model=iPhone-7',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-7-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 222,
    //         "name": "Speaker/Ringer Repair & Replacement for iPhone 7",
    //         "route": '/model/?device=iPhone/?model=iPhone-7',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-7-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 223,
    //         "name": "Mic Repair & Replacement for iPhone 7",
    //         "route": '/model/?device=iPhone/?model=iPhone-7',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-7-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 224,
    //         "name": "Ear Speaker Repair & Replacement for iPhone 7",
    //         "route": '/model/?device=iPhone/?model=iPhone-7',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-7-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 225,
    //         "name": "Front Camera Repair & Replacement for iPhone 7",
    //         "route": '/model/?device=iPhone/?model=iPhone-7',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-7-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 226,
    //         "name": "Rear Camera Repair & Replacement for iPhone 7",
    //         "route": '/model/?device=iPhone/?model=iPhone-7',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-7-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 227,
    //         "name": "Light & Motion Sensor Repair & Replacement for iPhone 7",
    //         "route": '/model/?device=iPhone/?model=iPhone-7',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-7-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 228,
    //         "name": "Headphone Repair & Replacement for iPhone 7",
    //         "route": '/model/?device=iPhone/?model=iPhone-7',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-7-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 229,
    //         "name": "Power Button Repair & Replacement for iPhone 7",
    //         "route": '/model/?device=iPhone/?model=iPhone-7',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-7-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 230,
    //         "name": "Volume Button Repair & Replacement for iPhone 7",
    //         "route": '/model/?device=iPhone/?model=iPhone-7',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-7-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 231,
    //         "name": "Frame & Housing Repair & Replacement for iPhone 7",
    //         "route": '/model/?device=iPhone/?model=iPhone-7',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-7-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 232,
    //         "name": "Other Problems - We will Contact you to find out more for iPhone 7",
    //         "route": '/model/?device=iPhone/?model=iPhone-7',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-7-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 233,
    //         "name": "Battery Repair & Replacement for iPhone 6s Plus",
    //         "route": '/model/?device=iPhone/?model=iPhone-6s-Plus',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-6s-Plus-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 234,
    //         "name": "Charging Flex/Strip Repair & Replacement for iPhone 6s Plus",
    //         "route": '/model/?device=iPhone/?model=iPhone-6s-Plus',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-6s-Plus-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 235,
    //         "name": "Speaker/Ringer Repair & Replacement for iPhone 6s Plus",
    //         "route": '/model/?device=iPhone/?model=iPhone-6s-Plus',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-6s-Plus-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 236,
    //         "name": "Mic Repair & Replacement for iPhone 6s Plus",
    //         "route": '/model/?device=iPhone/?model=iPhone-6s-Plus',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-6s-Plus-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 237,
    //         "name": "Ear Speaker Repair & Replacement for iPhone 6s Plus",
    //         "route": '/model/?device=iPhone/?model=iPhone-6s-Plus',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-6s-Plus-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 238,
    //         "name": "Front Camera Repair & Replacement for iPhone 6s Plus",
    //         "route": '/model/?device=iPhone/?model=iPhone-6s-Plus',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-6s-Plus-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 239,
    //         "name": "Rear Camera Repair & Replacement for iPhone 6s Plus",
    //         "route": '/model/?device=iPhone/?model=iPhone-6s-Plus',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-6s-Plus-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 240,
    //         "name": "Light & Motion Sensor Repair & Replacement for iPhone 6s Plus",
    //         "route": '/model/?device=iPhone/?model=iPhone-6s-Plus',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-6s-Plus-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 241,
    //         "name": "Headphone Repair & Replacement for iPhone 6s Plus",
    //         "route": '/model/?device=iPhone/?model=iPhone-6s-Plus',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-6s-Plus-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 242,
    //         "name": "Power Button Repair & Replacement for iPhone 6s Plus",
    //         "route": '/model/?device=iPhone/?model=iPhone-6s-Plus',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-6s-Plus-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 243,
    //         "name": "Volume Button Repair & Replacement for iPhone 6s Plus",
    //         "route": '/model/?device=iPhone/?model=iPhone-6s-Plus',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-6s-Plus-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 244,
    //         "name": "Frame & Housing Repair & Replacement for iPhone 6s Plus",
    //         "route": '/model/?device=iPhone/?model=iPhone-6s-Plus',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-6s-Plus-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 245,
    //         "name": "Other Problems - We will Contact you to find out more for iPhone 6s Plus",
    //         "route": '/model/?device=iPhone/?model=iPhone-6s-Plus',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-6s-Plus-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 246,
    //         "name": "Battery Repair & Replacement for iPhone 6s",
    //         "route": '/model/?device=iPhone/?model=iPhone-6s',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-6s-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 247,
    //         "name": "Charging Flex/Strip Repair & Replacement for iPhone 6s",
    //         "route": '/model/?device=iPhone/?model=iPhone-6s',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-6s-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 248,
    //         "name": "Speaker/Ringer Repair & Replacement for iPhone 6s",
    //         "route": '/model/?device=iPhone/?model=iPhone-6s',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-6s-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 249,
    //         "name": "Mic Repair & Replacement for iPhone 6s",
    //         "route": '/model/?device=iPhone/?model=iPhone-6s',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-6s-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 250,
    //         "name": "Ear Speaker Repair & Replacement for iPhone 6s",
    //         "route": '/model/?device=iPhone/?model=iPhone-6s',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-6s-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 251,
    //         "name": "Front Camera Repair & Replacement for iPhone 6s",
    //         "route": '/model/?device=iPhone/?model=iPhone-6s',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-6s-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 252,
    //         "name": "Rear Camera Repair & Replacement for iPhone 6s",
    //         "route": '/model/?device=iPhone/?model=iPhone-6s',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-6s-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 253,
    //         "name": "Light & Motion Sensor Repair & Replacement for iPhone 6s",
    //         "route": '/model/?device=iPhone/?model=iPhone-6s',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-6s-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 254,
    //         "name": "Headphone Repair & Replacement for iPhone 6s",
    //         "route": '/model/?device=iPhone/?model=iPhone-6s',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-6s-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 255,
    //         "name": "Power Button Repair & Replacement for iPhone 6s",
    //         "route": '/model/?device=iPhone/?model=iPhone-6s',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-6s-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 256,
    //         "name": "Volume Button Repair & Replacement for iPhone 6s",
    //         "route": '/model/?device=iPhone/?model=iPhone-6s',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-6s-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 257,
    //         "name": "Frame & Housing Repair & Replacement for iPhone 6s",
    //         "route": '/model/?device=iPhone/?model=iPhone-6s',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-6s-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 258,
    //         "name": "Other Problems - We will Contact you to find out more for iPhone 6s",
    //         "route": '/model/?device=iPhone/?model=iPhone-6s',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-6s-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 259,
    //         "name": "Battery Repair & Replacement for iPhone 6 Plus",
    //         "route": '/model/?device=iPhone/?model=iPhone-6-Plus',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-6-Plus-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 260,
    //         "name": "Charging Flex/Strip Repair & Replacement for iPhone 6 Plus",
    //         "route": '/model/?device=iPhone/?model=iPhone-6-Plus',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-6-Plus-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 261,
    //         "name": "Speaker/Ringer Repair & Replacement for iPhone 6 Plus",
    //         "route": '/model/?device=iPhone/?model=iPhone-6-Plus',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-6-Plus-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 262,
    //         "name": "Mic Repair & Replacement for iPhone 6 Plus",
    //         "route": '/model/?device=iPhone/?model=iPhone-6-Plus',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-6-Plus-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 263,
    //         "name": "Ear Speaker Repair & Replacement for iPhone 6 Plus",
    //         "route": '/model/?device=iPhone/?model=iPhone-6-Plus',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-6-Plus-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 264,
    //         "name": "Front Camera Repair & Replacement for iPhone 6 Plus",
    //         "route": '/model/?device=iPhone/?model=iPhone-6-Plus',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-6-Plus-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 265,
    //         "name": "Rear Camera Repair & Replacement for iPhone 6 Plus",
    //         "route": '/model/?device=iPhone/?model=iPhone-6-Plus',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-6-Plus-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 266,
    //         "name": "Light & Motion Sensor Repair & Replacement for iPhone 6 Plus",
    //         "route": '/model/?device=iPhone/?model=iPhone-6-Plus',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-6-Plus-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 267,
    //         "name": "Headphone Repair & Replacement for iPhone 6 Plus",
    //         "route": '/model/?device=iPhone/?model=iPhone-6-Plus',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-6-Plus-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 268,
    //         "name": "Power Button Repair & Replacement for iPhone 6 Plus",
    //         "route": '/model/?device=iPhone/?model=iPhone-6-Plus',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-6-Plus-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 269,
    //         "name": "Volume Button Repair & Replacement for iPhone 6 Plus",
    //         "route": '/model/?device=iPhone/?model=iPhone-6-Plus',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-6-Plus-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 270,
    //         "name": "Frame & Housing Repair & Replacement for iPhone 6 Plus",
    //         "route": '/model/?device=iPhone/?model=iPhone-6-Plus',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-6-Plus-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 271,
    //         "name": "Other Problems - We will Contact you to find out more for iPhone 6 Plus",
    //         "route": '/model/?device=iPhone/?model=iPhone-6-Plus',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-6-Plus-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 272,
    //         "name": "Battery Repair & Replacement for iPhone 6",
    //         "route": '/model/?device=iPhone/?model=iPhone-6',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-6-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 273,
    //         "name": "Charging Flex/Strip Repair & Replacement for iPhone 6",
    //         "route": '/model/?device=iPhone/?model=iPhone-6',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-6-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 274,
    //         "name": "Speaker/Ringer Repair & Replacement for iPhone 6",
    //         "route": '/model/?device=iPhone/?model=iPhone-6',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-6-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 275,
    //         "name": "Mic Repair & Replacement for iPhone 6",
    //         "route": '/model/?device=iPhone/?model=iPhone-6',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-6-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 276,
    //         "name": "Ear Speaker Repair & Replacement for iPhone 6",
    //         "route": '/model/?device=iPhone/?model=iPhone-6',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-6-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 277,
    //         "name": "Front Camera Repair & Replacement for iPhone 6",
    //         "route": '/model/?device=iPhone/?model=iPhone-6',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-6-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 278,
    //         "name": "Rear Camera Repair & Replacement for iPhone 6",
    //         "route": '/model/?device=iPhone/?model=iPhone-6',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-6-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 279,
    //         "name": "Light & Motion Sensor Repair & Replacement for iPhone 6",
    //         "route": '/model/?device=iPhone/?model=iPhone-6',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-6-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 280,
    //         "name": "Headphone Repair & Replacement for iPhone 6",
    //         "route": '/model/?device=iPhone/?model=iPhone-6',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-6-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 281,
    //         "name": "Power Button Repair & Replacement for iPhone 6",
    //         "route": '/model/?device=iPhone/?model=iPhone-6',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-6-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 282,
    //         "name": "Volume Button Repair & Replacement for iPhone 6",
    //         "route": '/model/?device=iPhone/?model=iPhone-6',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-6-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 283,
    //         "name": "Frame & Housing Repair & Replacement for iPhone 6",
    //         "route": '/model/?device=iPhone/?model=iPhone-6',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-6-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 284,
    //         "name": "Other Problems - We will Contact you to find out more for iPhone 6",
    //         "route": '/model/?device=iPhone/?model=iPhone-6',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-6-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 285,
    //         "name": "Battery Repair & Replacement for iPhone SE",
    //         "route": '/model/?device=iPhone/?model=iPhone-SE',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-SE-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 286,
    //         "name": "Charging Flex/Strip Repair & Replacement for iPhone SE",
    //         "route": '/model/?device=iPhone/?model=iPhone-SE',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-SE-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 287,
    //         "name": "Speaker/Ringer Repair & Replacement for iPhone SE",
    //         "route": '/model/?device=iPhone/?model=iPhone-SE',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-SE-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 288,
    //         "name": "Mic Repair & Replacement for iPhone SE",
    //         "route": '/model/?device=iPhone/?model=iPhone-SE',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-SE-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 289,
    //         "name": "Ear Speaker Repair & Replacement for iPhone SE",
    //         "route": '/model/?device=iPhone/?model=iPhone-SE',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-SE-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 290,
    //         "name": "Front Camera Repair & Replacement for iPhone SE",
    //         "route": '/model/?device=iPhone/?model=iPhone-SE',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-SE-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 291,
    //         "name": "Rear Camera Repair & Replacement for iPhone SE",
    //         "route": '/model/?device=iPhone/?model=iPhone-SE',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-SE-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 292,
    //         "name": "Light & Motion Sensor Repair & Replacement for iPhone SE",
    //         "route": '/model/?device=iPhone/?model=iPhone-SE',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-SE-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 293,
    //         "name": "Headphone Repair & Replacement for iPhone SE",
    //         "route": '/model/?device=iPhone/?model=iPhone-SE',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-SE-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 294,
    //         "name": "Power Button Repair & Replacement for iPhone SE",
    //         "route": '/model/?device=iPhone/?model=iPhone-SE',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-SE-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 295,
    //         "name": "Volume Button Repair & Replacement for iPhone SE",
    //         "route": '/model/?device=iPhone/?model=iPhone-SE',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-SE-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 296,
    //         "name": "Frame & Housing Repair & Replacement for iPhone SE",
    //         "route": '/model/?device=iPhone/?model=iPhone-SE',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-SE-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 297,
    //         "name": "Other Problems - We will Contact you to find out more for iPhone SE",
    //         "route": '/model/?device=iPhone/?model=iPhone-SE',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-SE-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 298,
    //         "name": "Battery Repair & Replacement for iPhone 5s",
    //         "route": '/model/?device=iPhone/?model=iPhone-5s',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-5s-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 299,
    //         "name": "Charging Flex/Strip Repair & Replacement for iPhone 5s",
    //         "route": '/model/?device=iPhone/?model=iPhone-5s',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-5s-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 300,
    //         "name": "Speaker/Ringer Repair & Replacement for iPhone 5s",
    //         "route": '/model/?device=iPhone/?model=iPhone-5s',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-5s-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 301,
    //         "name": "Mic Repair & Replacement for iPhone 5s",
    //         "route": '/model/?device=iPhone/?model=iPhone-5s',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-5s-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 302,
    //         "name": "Ear Speaker Repair & Replacement for iPhone 5s",
    //         "route": '/model/?device=iPhone/?model=iPhone-5s',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-5s-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 303,
    //         "name": "Front Camera Repair & Replacement for iPhone 5s",
    //         "route": '/model/?device=iPhone/?model=iPhone-5s',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-5s-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 304,
    //         "name": "Rear Camera Repair & Replacement for iPhone 5s",
    //         "route": '/model/?device=iPhone/?model=iPhone-5s',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-5s-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 305,
    //         "name": "Light & Motion Sensor Repair & Replacement for iPhone 5s",
    //         "route": '/model/?device=iPhone/?model=iPhone-5s',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-5s-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 306,
    //         "name": "Headphone Repair & Replacement for iPhone 5s",
    //         "route": '/model/?device=iPhone/?model=iPhone-5s',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-5s-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 307,
    //         "name": "Power Button Repair & Replacement for iPhone 5s",
    //         "route": '/model/?device=iPhone/?model=iPhone-5s',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-5s-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 308,
    //         "name": "Volume Button Repair & Replacement for iPhone 5s",
    //         "route": '/model/?device=iPhone/?model=iPhone-5s',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-5s-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 309,
    //         "name": "Frame & Housing Repair & Replacement for iPhone 5s",
    //         "route": '/model/?device=iPhone/?model=iPhone-5s',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-5s-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 310,
    //         "name": "Other Problems - We will Contact you to find out more for iPhone 5s",
    //         "route": '/model/?device=iPhone/?model=iPhone-5c',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-5c-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 311,
    //         "name": "Battery Repair & Replacement for iPhone 5c",
    //         "route": '/model/?device=iPhone/?model=iPhone-5c',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-5c-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 312,
    //         "name": "Charging Flex/Strip Repair & Replacement for iPhone 5c",
    //         "route": '/model/?device=iPhone/?model=iPhone-5c',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-5c-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 313,
    //         "name": "Speaker/Ringer Repair & Replacement for iPhone 5c",
    //         "route": '/model/?device=iPhone/?model=iPhone-5c',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-5c-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 314,
    //         "name": "Mic Repair & Replacement for iPhone 5c",
    //         "route": '/model/?device=iPhone/?model=iPhone-5c',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-5c-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 315,
    //         "name": "Ear Speaker Repair & Replacement for iPhone 5c",
    //         "route": '/model/?device=iPhone/?model=iPhone-5c',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-5c-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 316,
    //         "name": "Front Camera Repair & Replacement for iPhone 5c",
    //         "route": '/model/?device=iPhone/?model=iPhone-5c',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-5c-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 317,
    //         "name": "Rear Camera Repair & Replacement for iPhone 5c",
    //         "route": '/model/?device=iPhone/?model=iPhone-5c',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-5c-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 318,
    //         "name": "Light & Motion Sensor Repair & Replacement for iPhone 5c",
    //         "route": '/model/?device=iPhone/?model=iPhone-5c',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-5c-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 319,
    //         "name": "Headphone Repair & Replacement for iPhone 5c",
    //         "route": '/model/?device=iPhone/?model=iPhone-5c',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-5c-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 320,
    //         "name": "Power Button Repair & Replacement for iPhone 5c",
    //         "route": '/model/?device=iPhone/?model=iPhone-5c',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-5c-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 321,
    //         "name": "Volume Button Repair & Replacement for iPhone 5c",
    //         "route": '/model/?device=iPhone/?model=iPhone-5c',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-5c-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 322,
    //         "name": "Frame & Housing Repair & Replacement for iPhone 5c",
    //         "route": '/model/?device=iPhone/?model=iPhone-5c',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-5c-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 323,
    //         "name": "Other Problems - We will Contact you to find out more for iPhone 5c",
    //         "route": '/model/?device=iPhone/?model=iPhone-5c',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-5c-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 324,
    //         "name": "Battery Repair & Replacement for iPhone 5",
    //         "route": '/model/?device=iPhone/?model=iPhone-5',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-5-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 325,
    //         "name": "Charging Flex/Strip Repair & Replacement for iPhone 5",
    //         "route": '/model/?device=iPhone/?model=iPhone-5',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-5-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 326,
    //         "name": "Speaker/Ringer Repair & Replacement for iPhone 5",
    //         "route": '/model/?device=iPhone/?model=iPhone-5',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-5-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 327,
    //         "name": "Mic Repair & Replacement for iPhone 5",
    //         "route": '/model/?device=iPhone/?model=iPhone-5',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-5-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 328,
    //         "name": "Ear Speaker Repair & Replacement for iPhone 5",
    //         "route": '/model/?device=iPhone/?model=iPhone-5',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-5-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 329,
    //         "name": "Front Camera Repair & Replacement for iPhone 5",
    //         "route": '/model/?device=iPhone/?model=iPhone-5',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-5-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 330,
    //         "name": "Rear Camera Repair & Replacement for iPhone 5",
    //         "route": '/model/?device=iPhone/?model=iPhone-5',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-5-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 331,
    //         "name": "Light & Motion Sensor Repair & Replacement for iPhone 5",
    //         "route": '/model/?device=iPhone/?model=iPhone-5',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-5-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 332,
    //         "name": "Headphone Repair & Replacement for iPhone 5",
    //         "route": '/model/?device=iPhone/?model=iPhone-5',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-5-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 333,
    //         "name": "Power Button Repair & Replacement for iPhone 5",
    //         "route": '/model/?device=iPhone/?model=iPhone-5',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-5-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 334,
    //         "name": "Volume Button Repair & Replacement for iPhone 5",
    //         "route": '/model/?device=iPhone/?model=iPhone-5',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-5-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 335,
    //         "name": "Frame & Housing Repair & Replacement for iPhone 5",
    //         "route": '/model/?device=iPhone/?model=iPhone-5',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-5-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 336,
    //         "name": "Other Problems - We will Contact you to find out more for iPhone 5",
    //         "route": '/model/?device=iPhone/?model=iPhone-5',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-5-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 54,
    //         "name": "Screen/Display Repair & Replacement for iPhone 8",
    //         "route": '/model/?device=iPhone/?model=iPhone-8',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-8-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 55,
    //         "name": "Back Glass Repair & Replacement for iPhone 8",
    //         "route": '/model/?device=iPhone/?model=iPhone-8',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-8-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 337,
    //         "name": "Screen/Display Repair & Replacement for iPhone SE",
    //         "route": '/model/?device=iPhone/?model=iPhone-SE',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-SE-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 338,
    //         "name": "Back Glass Repair & Replacement for iPhone SE",
    //         "route": '/model/?device=iPhone/?model=iPhone-SE',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-SE-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 339,
    //         "name": "Screen/Display Repair & Replacement for iPhone 11 Pro Max",
    //         "route": '/model/?device=iPhone/?model=iPhone-11-Pro-Max',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-11-Pro-Max-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 340,
    //         "name": "Back Glass Repair & Replacement for iPhone 11 Pro Max",
    //         "route": '/model/?device=iPhone/?model=iPhone-11-Pro-Max',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-11-Pro-Max-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 341,
    //         "name": "Screen/Display Repair & Replacement for iPhone 11 Pro",
    //         "route": '/model/?device=iPhone/?model=iPhone-11-Pro',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-11-Pro-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 342,
    //         "name": "Back Glass Repair & Replacement for iPhone 11 Pro",
    //         "route": '/model/?device=iPhone/?model=iPhone-11-Pro',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-11-Pro-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 343,
    //         "name": "Screen/Display Repair & Replacement for iPhone 11",
    //         "route": '/model/?device=iPhone/?model=iPhone-11',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-11-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 344,
    //         "name": "Back Glass Repair & Replacement for iPhone 11",
    //         "route": '/model/?device=iPhone/?model=iPhone-11',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-11-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 345,
    //         "name": "Screen/Display Repair & Replacement for iPhone XS Max",
    //         "route": '/model/?device=iPhone/?model=iPhone-XS-Max',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-XS-Max-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 346,
    //         "name": "Back Glass Repair & Replacement for iPhone XS Max",
    //         "route": '/model/?device=iPhone/?model=iPhone-XS-Max',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-XS-Max-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 347,
    //         "name": "Screen/Display Repair & Replacement for iPhone XS",
    //         "route": '/model/?device=iPhone/?model=iPhone-XS',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-XS-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 348,
    //         "name": "Back Glass Repair & Replacement for iPhone XS",
    //         "route": '/model/?device=iPhone/?model=iPhone-XS',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-XS-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 349,
    //         "name": "Screen/Display Repair & Replacement for iPhone XR",
    //         "route": '/model/?device=iPhone/?model=iPhone-XR',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-XR-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 350,
    //         "name": "Back Glass Repair & Replacement for iPhone XR",
    //         "route": '/model/?device=iPhone/?model=iPhone-XR',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-XR-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 351,
    //         "name": "Screen/Display Repair & Replacement for iPhone X",
    //         "route": '/model/?device=iPhone/?model=iPhone-X',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-X-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 352,
    //         "name": "Back Glass Repair & Replacement for iPhone X",
    //         "route": '/model/?device=iPhone/?model=iPhone-X',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-X-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 353,
    //         "name": "Screen/Display Repair & Replacement for iPhone 8 Plus",
    //         "route": '/model/?device=iPhone/?model=iPhone-8-Plus',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-8-Plus-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 354,
    //         "name": "Back Glass Repair & Replacement for iPhone 8 Plus",
    //         "route": '/model/?device=iPhone/?model=iPhone-8-Plus',
    //         "asRoute": '/' + language + '/iPhone-Repair-Shop/iPhone-8-Plus-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 56,
    //         "name": "Screen/Display Repair & Replacement for iPad",
    //         "route": '/model/?device=iPad/?model=iPad',
    //         "asRoute": '/' + language + '/iPad-Repair-Shop/iPad-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 57,
    //         "name": "Battery Repair & Replacement for iPad",
    //         "route": '/model/?device=iPad/?model=iPad',
    //         "asRoute": '/' + language + '/iPad-Repair-Shop/iPad-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 58,
    //         "name": "Charging Flex/Strip Repair & Replacement for iPad",
    //         "route": '/model/?device=iPad/?model=iPad',
    //         "asRoute": '/' + language + '/iPad-Repair-Shop/iPad-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 59,
    //         "name": "Speaker/Ringer Repair & Replacement for iPad",
    //         "route": '/model/?device=iPad/?model=iPad',
    //         "asRoute": '/' + language + '/iPad-Repair-Shop/iPad-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 60,
    //         "name": "Mic Repair & Replacement for iPad",
    //         "route": '/model/?device=iPad/?model=iPad',
    //         "asRoute": '/' + language + '/iPad-Repair-Shop/iPad-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 61,
    //         "name": "Ear Speaker Repair & Replacement for iPad",
    //         "route": '/model/?device=iPad/?model=iPad',
    //         "asRoute": '/' + language + '/iPad-Repair-Shop/iPad-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 62,
    //         "name": "Front Camera Repair & Replacement for iPad",
    //         "route": '/model/?device=iPad/?model=iPad',
    //         "asRoute": '/' + language + '/iPad-Repair-Shop/iPad-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 63,
    //         "name": "Rear Camera Repair & Replacement for iPad",
    //         "route": '/model/?device=iPad/?model=iPad',
    //         "asRoute": '/' + language + '/iPad-Repair-Shop/iPad-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 64,
    //         "name": "Light & Motion Sensor Repair & Replacement for iPad",
    //         "route": '/model/?device=iPad/?model=iPad',
    //         "asRoute": '/' + language + '/iPad-Repair-Shop/iPad-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 65,
    //         "name": "Headphone Repair & Replacement for iPad",
    //         "route": '/model/?device=iPad/?model=iPad',
    //         "asRoute": '/' + language + '/iPad-Repair-Shop/iPad-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 66,
    //         "name": "Power Button Repair & Replacement for iPad",
    //         "route": '/model/?device=iPad/?model=iPad',
    //         "asRoute": '/' + language + '/iPad-Repair-Shop/iPad-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 67,
    //         "name": "Volume Button Repair & Replacement for iPad",
    //         "route": '/model/?device=iPad/?model=iPad',
    //         "asRoute": '/' + language + '/iPad-Repair-Shop/iPad-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 68,
    //         "name": "Frame & Housing Repair & Replacement for iPad",
    //         "route": '/model/?device=iPad/?model=iPad',
    //         "asRoute": '/' + language + '/iPad-Repair-Shop/iPad-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 69,
    //         "name": "Other Problems - We will Contact you to find out more for iPad",
    //         "route": '/model/?device=iPad/?model=iPad',
    //         "asRoute": '/' + language + '/iPad-Repair-Shop/iPad-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 355,
    //         "name": "Screen/Display Repair & Replacement for iPad Air",
    //         "route": '/model/?device=iPad/?model=iPad-Air',
    //         "asRoute": '/' + language + '/iPad-Repair-Shop/iPad-Air-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 356,
    //         "name": "Battery Repair & Replacement for iPad Air",
    //         "route": '/model/?device=iPad/?model=iPad-Air',
    //         "asRoute": '/' + language + '/iPad-Repair-Shop/iPad-Air-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 357,
    //         "name": "Charging Flex/Strip Repair & Replacement for iPad Air",
    //         "route": '/model/?device=iPad/?model=iPad-Air',
    //         "asRoute": '/' + language + '/iPad-Repair-Shop/iPad-Air-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 358,
    //         "name": "Speaker/Ringer Repair & Replacement for iPad Air",
    //         "route": '/model/?device=iPad/?model=iPad-Air',
    //         "asRoute": '/' + language + '/iPad-Repair-Shop/iPad-Air-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 359,
    //         "name": "Mic Repair & Replacement for iPad Air",
    //         "route": '/model/?device=iPad/?model=iPad-Air',
    //         "asRoute": '/' + language + '/iPad-Repair-Shop/iPad-Air-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 360,
    //         "name": "Ear Speaker Repair & Replacement for iPad Air",
    //         "route": '/model/?device=iPad/?model=iPad-Air',
    //         "asRoute": '/' + language + '/iPad-Repair-Shop/iPad-Air-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 361,
    //         "name": "Front Camera Repair & Replacement for iPad Air",
    //         "route": '/model/?device=iPad/?model=iPad-Air',
    //         "asRoute": '/' + language + '/iPad-Repair-Shop/iPad-Air-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 362,
    //         "name": "Rear Camera Repair & Replacement for iPad Air",
    //         "route": '/model/?device=iPad/?model=iPad-Air',
    //         "asRoute": '/' + language + '/iPad-Repair-Shop/iPad-Air-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 363,
    //         "name": "Light & Motion Sensor Repair & Replacement for iPad Air",
    //         "route": '/model/?device=iPad/?model=iPad-Air',
    //         "asRoute": '/' + language + '/iPad-Repair-Shop/iPad-Air-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 364,
    //         "name": "Headphone Repair & Replacement for iPad Air",
    //         "route": '/model/?device=iPad/?model=iPad-Air',
    //         "asRoute": '/' + language + '/iPad-Repair-Shop/iPad-Air-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 365,
    //         "name": "Power Button Repair & Replacement for iPad Air",
    //         "route": '/model/?device=iPad/?model=iPad-Air',
    //         "asRoute": '/' + language + '/iPad-Repair-Shop/iPad-Air-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 366,
    //         "name": "Volume Button Repair & Replacement for iPad Air",
    //         "route": '/model/?device=iPad/?model=iPad-Air',
    //         "asRoute": '/' + language + '/iPad-Repair-Shop/iPad-Air-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 367,
    //         "name": "Frame & Housing Repair & Replacement for iPad Air",
    //         "route": '/model/?device=iPad/?model=iPad-Air',
    //         "asRoute": '/' + language + '/iPad-Repair-Shop/iPad-Air-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 368,
    //         "name": "Other Problems - We will Contact you to find out more for iPad Air",
    //         "route": '/model/?device=iPad/?model=iPad-Air',
    //         "asRoute": '/' + language + '/iPad-Repair-Shop/iPad-Air-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 369,
    //         "name": "Screen/Display Repair & Replacement for iPad Mini",
    //         "route": '/model/?device=iPad/?model=iPad-Mini',
    //         "asRoute": '/' + language + '/iPad-Repair-Shop/iPad-Mini-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 370,
    //         "name": "Battery Repair & Replacement for iPad Mini",
    //         "route": '/model/?device=iPad/?model=iPad-Mini',
    //         "asRoute": '/' + language + '/iPad-Repair-Shop/iPad-Mini-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 371,
    //         "name": "Charging Flex/Strip Repair & Replacement for iPad Mini",
    //         "route": '/model/?device=iPad/?model=iPad-Mini',
    //         "asRoute": '/' + language + '/iPad-Repair-Shop/iPad-Mini-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 372,
    //         "name": "Speaker/Ringer Repair & Replacement for iPad Mini",
    //         "route": '/model/?device=iPad/?model=iPad-Mini',
    //         "asRoute": '/' + language + '/iPad-Repair-Shop/iPad-Mini-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 373,
    //         "name": "Mic Repair & Replacement for iPad Mini",
    //         "route": '/model/?device=iPad/?model=iPad-Mini',
    //         "asRoute": '/' + language + '/iPad-Repair-Shop/iPad-Mini-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 374,
    //         "name": "Ear Speaker Repair & Replacement for iPad Mini",
    //         "route": '/model/?device=iPad/?model=iPad-Mini',
    //         "asRoute": '/' + language + '/iPad-Repair-Shop/iPad-Mini-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 375,
    //         "name": "Front Camera Repair & Replacement for iPad Mini",
    //         "route": '/model/?device=iPad/?model=iPad-Mini',
    //         "asRoute": '/' + language + '/iPad-Repair-Shop/iPad-Mini-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 376,
    //         "name": "Rear Camera Repair & Replacement for iPad Mini",
    //         "route": '/model/?device=iPad/?model=iPad-Mini',
    //         "asRoute": '/' + language + '/iPad-Repair-Shop/iPad-Mini-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 377,
    //         "name": "Light & Motion Sensor Repair & Replacement for iPad Mini",
    //         "route": '/model/?device=iPad/?model=iPad-Mini',
    //         "asRoute": '/' + language + '/iPad-Repair-Shop/iPad-Mini-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 378,
    //         "name": "Headphone Repair & Replacement for iPad Mini",
    //         "route": '/model/?device=iPad/?model=iPad-Mini',
    //         "asRoute": '/' + language + '/iPad-Repair-Shop/iPad-Mini-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 379,
    //         "name": "Power Button Repair & Replacement for iPad Mini",
    //         "route": '/model/?device=iPad/?model=iPad-Mini',
    //         "asRoute": '/' + language + '/iPad-Repair-Shop/iPad-Mini-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 380,
    //         "name": "Volume Button Repair & Replacement for iPad Mini",
    //         "route": '/model/?device=iPad/?model=iPad-Mini',
    //         "asRoute": '/' + language + '/iPad-Repair-Shop/iPad-Mini-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 381,
    //         "name": "Frame & Housing Repair & Replacement for iPad Mini",
    //         "route": '/model/?device=iPad/?model=iPad-Mini',
    //         "asRoute": '/' + language + '/iPad-Repair-Shop/iPad-Mini-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 382,
    //         "name": "Other Problems - We will Contact you to find out more for iPad Mini",
    //         "route": '/model/?device=iPad/?model=iPad-Mini',
    //         "asRoute": '/' + language + '/iPad-Repair-Shop/iPad-Mini-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 369,
    //         "name": "Screen/Display Repair & Replacement for iPad Pro",
    //         "route": '/model/?device=iPad/?model=iPad-Pro',
    //         "asRoute": '/' + language + '/iPad-Repair-Shop/iPad-Pro-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 370,
    //         "name": "Battery Repair & Replacement for iPad Pro",
    //         "route": '/model/?device=iPad/?model=iPad-Pro',
    //         "asRoute": '/' + language + '/iPad-Repair-Shop/iPad-Pro-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 371,
    //         "name": "Charging Flex/Strip Repair & Replacement for iPad Pro",
    //         "route": '/model/?device=iPad/?model=iPad-Pro',
    //         "asRoute": '/' + language + '/iPad-Repair-Shop/iPad-Pro-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 372,
    //         "name": "Speaker/Ringer Repair & Replacement for iPad Pro",
    //         "route": '/model/?device=iPad/?model=iPad-Pro',
    //         "asRoute": '/' + language + '/iPad-Repair-Shop/iPad-Pro-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 373,
    //         "name": "Mic Repair & Replacement for iPad Pro",
    //         "route": '/model/?device=iPad/?model=iPad-Pro',
    //         "asRoute": '/' + language + '/iPad-Repair-Shop/iPad-Pro-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 374,
    //         "name": "Ear Speaker Repair & Replacement for iPad Pro",
    //         "route": '/model/?device=iPad/?model=iPad-Pro',
    //         "asRoute": '/' + language + '/iPad-Repair-Shop/iPad-Pro-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 375,
    //         "name": "Front Camera Repair & Replacement for iPad Pro",
    //         "route": '/model/?device=iPad/?model=iPad-Pro',
    //         "asRoute": '/' + language + '/iPad-Repair-Shop/iPad-Pro-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 376,
    //         "name": "Rear Camera Repair & Replacement for iPad Pro",
    //         "route": '/model/?device=iPad/?model=iPad-Pro',
    //         "asRoute": '/' + language + '/iPad-Repair-Shop/iPad-Pro-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 377,
    //         "name": "Light & Motion Sensor Repair & Replacement for iPad Pro",
    //         "route": '/model/?device=iPad/?model=iPad-Pro',
    //         "asRoute": '/' + language + '/iPad-Repair-Shop/iPad-Pro-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 378,
    //         "name": "Headphone Repair & Replacement for iPad Pro",
    //         "route": '/model/?device=iPad/?model=iPad-Pro',
    //         "asRoute": '/' + language + '/iPad-Repair-Shop/iPad-Pro-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 379,
    //         "name": "Power Button Repair & Replacement for iPad Pro",
    //         "route": '/model/?device=iPad/?model=iPad-Pro',
    //         "asRoute": '/' + language + '/iPad-Repair-Shop/iPad-Pro-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 380,
    //         "name": "Volume Button Repair & Replacement for iPad Pro",
    //         "route": '/model/?device=iPad/?model=iPad-Pro',
    //         "asRoute": '/' + language + '/iPad-Repair-Shop/iPad-Pro-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 381,
    //         "name": "Frame & Housing Repair & Replacement for iPad Pro",
    //         "route": '/model/?device=iPad/?model=iPad-Pro',
    //         "asRoute": '/' + language + '/iPad-Repair-Shop/iPad-Pro-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 382,
    //         "name": "Other Problems - We will Contact you to find out more for iPad Pro",
    //         "route": '/model/?device=iPad/?model=iPad-Pro',
    //         "asRoute": '/' + language + '/iPad-Repair-Shop/iPad-Pro-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 70,
    //         "name": "MacBook Screen/Display Repair & Replacement for MacBook",
    //          "route": '/model/?device=MacBook/?model=MacBook',
    //         "asRoute": '/' + language + '/MacBook-Repair-Shop/MacBook-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 71,
    //         "name": "MacBook Hard Disk Drive Repair & Replacement for MacBook",
    //          "route": '/model/?device=MacBook/?model=MacBook',
    //         "asRoute": '/' + language + '/MacBook-Repair-Shop/MacBook-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 72,
    //         "name": "MacBook Motherboard Repair & Replacement for MacBook",
    //          "route": '/model/?device=MacBook/?model=MacBook',
    //         "asRoute": '/' + language + '/MacBook-Repair-Shop/MacBook-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 73,
    //         "name": "MacBook RAM Addition, Repair & Replacement for MacBook",
    //          "route": '/model/?device=MacBook/?model=MacBook',
    //         "asRoute": '/' + language + '/MacBook-Repair-Shop/MacBook-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 74,
    //         "name": "Mac OSX support for MacBook",
    //          "route": '/model/?device=MacBook/?model=MacBook',
    //         "asRoute": '/' + language + '/MacBook-Repair-Shop/MacBook-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 75,
    //         "name": "MacBook Battery Repair & Replacement for MacBook",
    //          "route": '/model/?device=MacBook/?model=MacBook',
    //         "asRoute": '/' + language + '/MacBook-Repair-Shop/MacBook-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 76,
    //         "name": "MacBook Keyboard Repair & Replacement for MacBook",
    //          "route": '/model/?device=MacBook/?model=MacBook',
    //         "asRoute": '/' + language + '/MacBook-Repair-Shop/MacBook-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 77,
    //         "name": "MacBook Camera Repair & Replacement for MacBook",
    //          "route": '/model/?device=MacBook/?model=MacBook',
    //         "asRoute": '/' + language + '/MacBook-Repair-Shop/MacBook-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 78,
    //         "name": "MacBook Trackpad Repair & Replacement for MacBook",
    //          "route": '/model/?device=MacBook/?model=MacBook',
    //         "asRoute": '/' + language + '/MacBook-Repair-Shop/MacBook-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 79,
    //         "name": "Other Problems - We will Contact you to find out more for MacBook",
    //          "route": '/model/?device=MacBook/?model=MacBook',
    //         "asRoute": '/' + language + '/MacBook-Repair-Shop/MacBook-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 383,
    //         "name": "MacBook Screen/Display Repair & Replacement for MacBook Pro Retina",
    //          "route": '/model/?device=MacBook/?model=MacBook-Pro-Retina',
    //         "asRoute": '/' + language + '/MacBook-Repair-Shop/MacBook-Pro-Retina-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 384,
    //         "name": "MacBook Hard Disk Drive Repair & Replacement for MacBook Pro Retina",
    //          "route": '/model/?device=MacBook/?model=MacBook-Pro-Retina',
    //         "asRoute": '/' + language + '/MacBook-Repair-Shop/MacBook-Pro-Retina-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 385,
    //         "name": "MacBook Motherboard Repair & Replacement for MacBook Pro Retina",
    //          "route": '/model/?device=MacBook/?model=MacBook-Pro-Retina',
    //         "asRoute": '/' + language + '/MacBook-Repair-Shop/MacBook-Pro-Retina-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 386,
    //         "name": "MacBook RAM Addition, Repair & Replacement for MacBook Pro Retina",
    //          "route": '/model/?device=MacBook/?model=MacBook-Pro-Retina',
    //         "asRoute": '/' + language + '/MacBook-Repair-Shop/MacBook-Pro-Retina-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 387,
    //         "name": "Mac OSX support for MacBook Pro Retina",
    //          "route": '/model/?device=MacBook/?model=MacBook-Pro-Retina',
    //         "asRoute": '/' + language + '/MacBook-Repair-Shop/MacBook-Pro-Retina-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 388,
    //         "name": "MacBook Battery Repair & Replacement for MacBook Pro Retina",
    //          "route": '/model/?device=MacBook/?model=MacBook-Pro-Retina',
    //         "asRoute": '/' + language + '/MacBook-Repair-Shop/MacBook-Pro-Retina-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 389,
    //         "name": "MacBook Keyboard Repair & Replacement for MacBook Pro Retina",
    //          "route": '/model/?device=MacBook/?model=MacBook-Pro-Retina',
    //         "asRoute": '/' + language + '/MacBook-Repair-Shop/MacBook-Pro-Retina-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 390,
    //         "name": "MacBook Camera Repair & Replacement for MacBook Pro Retina",
    //          "route": '/model/?device=MacBook/?model=MacBook-Pro-Retina',
    //         "asRoute": '/' + language + '/MacBook-Repair-Shop/MacBook-Pro-Retina-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 391,
    //         "name": "MacBook Trackpad Repair & Replacement for MacBook Pro Retina",
    //          "route": '/model/?device=MacBook/?model=MacBook-Pro-Retina',
    //         "asRoute": '/' + language + '/MacBook-Repair-Shop/MacBook-Pro-Retina-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 392,
    //         "name": "Other Problems - We will Contact you to find out more for MacBook Pro Retina",
    //          "route": '/model/?device=MacBook/?model=MacBook-Pro-Retina',
    //         "asRoute": '/' + language + '/MacBook-Repair-Shop/MacBook-Pro-Retina-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 393,
    //         "name": "MacBook Screen/Display Repair & Replacement for MacBook Pro",
    //          "route": '/model/?device=MacBook/?model=MacBook-Pro',
    //         "asRoute": '/' + language + '/MacBook-Repair-Shop/MacBook-Pro-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 394,
    //         "name": "MacBook Hard Disk Drive Repair & Replacement for MacBook Pro",
    //          "route": '/model/?device=MacBook/?model=MacBook-Pro',
    //         "asRoute": '/' + language + '/MacBook-Repair-Shop/MacBook-Pro-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 395,
    //         "name": "MacBook Motherboard Repair & Replacement for MacBook Pro",
    //          "route": '/model/?device=MacBook/?model=MacBook-Pro',
    //         "asRoute": '/' + language + '/MacBook-Repair-Shop/MacBook-Pro-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 396,
    //         "name": "MacBook RAM Addition, Repair & Replacement for MacBook Pro",
    //          "route": '/model/?device=MacBook/?model=MacBook-Pro',
    //         "asRoute": '/' + language + '/MacBook-Repair-Shop/MacBook-Pro-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 397,
    //         "name": "Mac OSX support for MacBook Pro",
    //          "route": '/model/?device=MacBook/?model=MacBook-Pro',
    //         "asRoute": '/' + language + '/MacBook-Repair-Shop/MacBook-Pro-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 398,
    //         "name": "MacBook Battery Repair & Replacement for MacBook Pro",
    //          "route": '/model/?device=MacBook/?model=MacBook-Pro',
    //         "asRoute": '/' + language + '/MacBook-Repair-Shop/MacBook-Pro-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 399,
    //         "name": "MacBook Keyboard Repair & Replacement for MacBook Pro",
    //          "route": '/model/?device=MacBook/?model=MacBook-Pro',
    //         "asRoute": '/' + language + '/MacBook-Repair-Shop/MacBook-Pro-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 400,
    //         "name": "MacBook Camera Repair & Replacement for MacBook Pro",
    //          "route": '/model/?device=MacBook/?model=MacBook-Pro',
    //         "asRoute": '/' + language + '/MacBook-Repair-Shop/MacBook-Pro-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 401,
    //         "name": "MacBook Trackpad Repair & Replacement for MacBook Pro",
    //          "route": '/model/?device=MacBook/?model=MacBook-Pro',
    //         "asRoute": '/' + language + '/MacBook-Repair-Shop/MacBook-Pro-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 402,
    //         "name": "Other Problems - We will Contact you to find out more for MacBook Pro",
    //          "route": '/model/?device=MacBook/?model=MacBook-Pro',
    //         "asRoute": '/' + language + '/MacBook-Repair-Shop/MacBook-Pro-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 403,
    //         "name": "MacBook Screen/Display Repair & Replacement for MacBook Air",
    //          "route": '/model/?device=MacBook/?model=MacBook-Air',
    //         "asRoute": '/' + language + '/MacBook-Repair-Shop/MacBook-Air-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 404,
    //         "name": "MacBook Hard Disk Drive Repair & Replacement for MacBook Air",
    //          "route": '/model/?device=MacBook/?model=MacBook-Air',
    //         "asRoute": '/' + language + '/MacBook-Repair-Shop/MacBook-Air-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 405,
    //         "name": "MacBook Motherboard Repair & Replacement for MacBook Air",
    //          "route": '/model/?device=MacBook/?model=MacBook-Air',
    //         "asRoute": '/' + language + '/MacBook-Repair-Shop/MacBook-Air-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 406,
    //         "name": "MacBook RAM Addition, Repair & Replacement for MacBook Air",
    //          "route": '/model/?device=MacBook/?model=MacBook-Air',
    //         "asRoute": '/' + language + '/MacBook-Repair-Shop/MacBook-Air-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 407,
    //         "name": "Mac OSX support for MacBook Air",
    //          "route": '/model/?device=MacBook/?model=MacBook-Air',
    //         "asRoute": '/' + language + '/MacBook-Repair-Shop/MacBook-Air-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 408,
    //         "name": "MacBook Battery Repair & Replacement for MacBook Air",
    //          "route": '/model/?device=MacBook/?model=MacBook-Air',
    //         "asRoute": '/' + language + '/MacBook-Repair-Shop/MacBook-Air-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 409,
    //         "name": "MacBook Keyboard Repair & Replacement for MacBook Air",
    //          "route": '/model/?device=MacBook/?model=MacBook-Air',
    //         "asRoute": '/' + language + '/MacBook-Repair-Shop/MacBook-Air-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 410,
    //         "name": "MacBook Camera Repair & Replacement for MacBook Air",
    //          "route": '/model/?device=MacBook/?model=MacBook-Air',
    //         "asRoute": '/' + language + '/MacBook-Repair-Shop/MacBook-Air-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 411,
    //         "name": "MacBook Trackpad Repair & Replacement for MacBook Air",
    //          "route": '/model/?device=MacBook/?model=MacBook-Air',
    //         "asRoute": '/' + language + '/MacBook-Repair-Shop/MacBook-Air-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 412,
    //         "name": "Other Problems - We will Contact you to find out more for MacBook Air",
    //          "route": '/model/?device=MacBook/?model=MacBook-Air',
    //         "asRoute": '/' + language + '/MacBook-Repair-Shop/MacBook-Air-Repair',
    //         "isIssue": true
    //     },
    //     {
    //         "id": 80,
    //         "name": "About Us",
    //         "route": '/aboutUs',
    //         "asRoute": '/aboutUs',
    //         "isIssue": false
    //     },
    //     {
    //         "id": 81,
    //         "name": "Our Offers",
    //         "route": '/offers',
    //         "asRoute": '/offers',
    //         "isIssue": false
    //     },
    //     {
    //         "id": 82,
    //         "name": "Frequently Asked Questions",
    //         "route": '/faq',
    //         "asRoute": '/faq',
    //         "isIssue": false
    //     },
    //     {
    //         "id": 83,
    //         "name": "Privacy",
    //         "route": '/privacy',
    //         "asRoute": '/privacy',
    //         "isIssue": false
    //     },
    //     {
    //         "id": 84,
    //         "name": "Home",
    //         "route": '/',
    //         "asRoute": '/',
    //         "isIssue": false
    //     },
    //     {
    //         "id": 85,
    //         "name": "How does GadgetZippy.com work?",
    //         "route": '/faq',
    //         "asRoute": '/faq',
    //         "isIssue": false
    //     },
    //     {
    //         "id": 86,
    //         "name": "What are the cities GadgetZippy.com operates in?",
    //         "route": '/faq',
    //         "asRoute": '/faq',
    //         "isIssue": false
    //     },
    //     {
    //         "id": 87,
    //         "name": "How do I place a service request at GadgetZippy.com?",
    //         "route": '/faq',
    //         "asRoute": '/faq',
    //         "isIssue": false
    //     },
    //     {
    //         "id": 88,
    //         "name": "How much does GadgetZippy.com charge for its repair service?",
    //         "route": '/faq',
    //         "asRoute": '/faq',
    //         "isIssue": false
    //     },
    //     {
    //         "id": 89,
    //         "name": "What time does it take for Apple Device to be repaired?",
    //         "route": '/faq',
    //         "asRoute": '/faq',
    //         "isIssue": false
    //     },
    //     {
    //         "id": 90,
    //         "name": "Is there a warranty on the repair service undertaken by GadgetZippy.com?",
    //         "route": '/faq',
    //         "asRoute": '/faq',
    //         "isIssue": false
    //     },
    //     {
    //         "id": 91,
    //         "name": "How safe is my iPhone/iPad/iWatch/MacBook with GadgetZippy.com?",
    //         "route": '/faq',
    //         "asRoute": '/faq',
    //         "isIssue": false
    //     },
    //     {
    //         "id": 92,
    //         "name": "Is there a warranty on the repair service undertaken by GadgetZippy.com ?",
    //         "route": '/faq',
    //         "asRoute": '/faq',
    //         "isIssue": false
    //     },
    //     {
    //         "id": 93,
    //         "name": "Is GadgetZippy.com authorized service center?",
    //         "route": '/faq',
    //         "asRoute": '/faq',
    //         "isIssue": false
    //     },
    //     {
    //         "id": 94,
    //         "name": "What about the data on my Device?",
    //         "route": '/faq',
    //         "asRoute": '/faq',
    //         "isIssue": false
    //     },
    // ];
    let result = await SERVICES._searchData({location: language})
    console.log(result,"search")
    return result.searchData;
};
export default {
    _searchData
};